import { render } from "./subMenuForEvent.vue?vue&type=template&id=2b774932&scoped=true"
import script from "./subMenuForEvent.vue?vue&type=script&lang=js"
export * from "./subMenuForEvent.vue?vue&type=script&lang=js"

import "./subMenuForEvent.vue?vue&type=style&index=0&id=2b774932&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b774932"]])

export default __exports__